const handleKeyDown = (e) => {
    if (
        [8, 46, 9, 27, 13, 37, 38, 39, 40].indexOf(e.keyCode) !== -1 ||
        (e.keyCode === 65 && (e.ctrlKey || e.metaKey)) ||
        (e.keyCode === 67 && (e.ctrlKey || e.metaKey)) ||
        (e.keyCode === 88 && (e.ctrlKey || e.metaKey))
    ) {
        return;
    }

    if (
        (e.shiftKey || e.keyCode < 48 || e.keyCode > 57) &&
        (e.keyCode < 96 || e.keyCode > 105)
    ) {
        e.preventDefault();
    }
};

const validateName = (name) => {
    if (name.trim().length === 0) {
        return "This field is required";
    } else if (name.trim().length < 3) {
        return "Minimum 3 characters required";
    }
    return "";
};

const validateCellular = (number) => {
    if (!number) {
        return "This field is required";
    } else if (number.length < 10) {
        return "Cellular number must be at least 10 digits";
    } else if (number.length > 15) {
        return "Cellular number must not exceed 15 digits";
    }
    return "";
};

const validateIdTypeDescription = (value, idType) => {
    if (idType === "1") {
        // KTP
        if (!/^\d+$/.test(value)) {
            return "KTP must contain only numbers";
        }
        if (value.length !== 16) {
            return "KTP must be exactly 16 digits";
        }
    } else if (idType === "2") {
        // Passport
        if (value.length < 6 || value.length > 15) {
            return "Passport number must be between 6 and 15 characters";
        }
        if (!/^[A-Z0-9]+$/.test(value)) {
            return "Passport number must contain only uppercase letters and numbers";
        }
    }
    return "";
};

const CalculatePersentaseProfile = (student_status) => {
    const fams_check = student_status.reff_family ? student_status.reff_family.filter(item => item.type === "MOTHER" || item.type === "FATHER") : [];
    const fams_map_addr = fams_check && fams_check.map(item =>{
        const addr = item.address;
        if(addr){
            const t_addr = Object.values(addr).length;
            const last_addr = addr[t_addr - 1] || "";
            
            if(last_addr && Object.values(last_addr).length > 0){
                item.cellular = last_addr?.cellular1 || "";
                item.email = last_addr?.email || "";
                item.fam_id = last_addr?.id || 0;
            }
        }else{
            item.cellular = "";
            item.email = "";
            item.fam_id = 0;
        }
        return item;
    });
    const required_key = {
        bio: ['firstname', 'lastname', 'birthdate', 'birthplace', 'birthcountry_id', 'gender', 'religion_id', 'citizenship_id', 'cellular', 'idtype_id', 'idtype_description', 'nisn'],
        address: ['address', 'city_id', 'country_id', 'province_id', 'kecamatan_id', 'kelurahan', 'postalcode'],
        family: ['firstname', 'profession_id', 'cellular', 'email']
    }

    let total_incomplete = 0;
    let total_fields = 0;
    let incomplete_fields = {
        bio: [],
        address: [],
        family: []
    };

    // Check bio fields
    required_key.bio.forEach(key => {
        total_fields++;
        if (!student_status[key] || student_status[key] === '') {
            total_incomplete++;
            incomplete_fields.bio.push(key);
        }
    });

    // Check address fields
    if (student_status.reff_address && student_status.reff_address.length > 0) {
        const primaryAddress = student_status.reff_address[0];
        required_key.address.forEach(key => {
            total_fields++;
            if (!primaryAddress[key] || primaryAddress[key] === '') {
                total_incomplete++;
                incomplete_fields.address.push(key);
            }
        });
    } else {
        total_incomplete += required_key.address.length;
        total_fields += required_key.address.length;
        incomplete_fields.address = [...required_key.address];
    }


    const familyTypes = ["MOTHER", "FATHER"];
    console.log(fams_map_addr);
    familyTypes.forEach(familyType => {
        const familyMember = fams_map_addr.find(item => item.type === familyType);
        console.log(familyType,familyMember);
        if (familyMember) {
            required_key.family.forEach(key => {
                total_fields++;
                console.log(`${key}:`, familyMember[key]);
                if (!familyMember[key] || familyMember[key] === '') {
                    total_incomplete++;
                    incomplete_fields.family.push(`${familyType}_${key}`);
                }
            });
        } else {
            total_incomplete += required_key.family.length;
            total_fields += required_key.family.length;
            incomplete_fields.family.push(`${familyType}_MISSING`);
        }
    });

    const completion_percentage = ((total_fields - total_incomplete) / total_fields) * 100;

    return {
        total_fields,
        total_incomplete,
        completion_percentage: Math.round(completion_percentage),
        incomplete_fields
    };
}

export { handleKeyDown, validateCellular, validateName, validateIdTypeDescription, CalculatePersentaseProfile }